module.exports = __webpack_public_path__ + "img/danger-red.53365662.png";